import React from "react";

export default class Separator extends React.Component {
  render() {
    return <span className="separator">|</span>;
  }
}
